export const ERR_PAGE_NOT_FOUND = "PAGE_NOT_FOUND";
export const ERR_UNAUTHORIZED_QUESTIONNAIRE =
  "Unauthorized questionnaire access";
